import { useCallback, useState } from "react";

function useHorizontalPagination(start = 0, size) {
  const [page, setPage] = useState(start);

  const onPageRight = useCallback(() => {
    if (page + 1 <= size) {
      setPage(page + 1);
    }
  }, [page, size]);

  const onPageLeft = useCallback(() => {
    if (page > 0) {
      setPage(page - 1);
    }
  }, [page]);

  return {
    page,
    onPageRight,
    onPageLeft,
  };
}

export default useHorizontalPagination;
